import { useState } from 'react';
import { testimonials } from '@/mocks/homeData';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`text-sm ${star <= rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
        ></i>
      ))}
    </div>
  );
}

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);

  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            <strong className="text-primary-500">用户评价</strong>
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            来自真实用户的声音，看看他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.slice(activeIndex * itemsPerPage, (activeIndex + 1) * itemsPerPage).map((t, i) => (
            <div
              key={i}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="font-medium text-foreground-900 text-sm">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.date}</div>
                </div>
              </div>
              <StarRating rating={t.rating} />
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {t.comment}
              </p>
            </div>
          ))}
        </div>

        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 mt-8">
            {Array.from({ length: totalPages }).map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  i === activeIndex
                    ? 'bg-primary-500 w-6'
                    : 'bg-background-300 hover:bg-background-400'
                }`}
                aria-label={`第${i + 1}页`}
              ></button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}